import './Alerts.scss';
import React, { useEffect, useState } from "react";
import { useAlertsContext } from '../../../contexts/AlertsContext';
import bellIcon from '../../../assets/icons/bell-icon-colored.png';
import emailDemoIcon from '../../../assets/icons/211shots_so.png';
import axios from 'axios';
import { useUserContext } from '../../../contexts/UserContext.js';
import Spinner from '../../Spinner';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import AlertsFireCard from './AlertsFireCard.js';
import AlertsAreaCard from './AlertsAreaCard.js';
import AlertsModal from './AlertsModal.js';
import { Fire, MapPinAreaIcon, InfoIcon} from '@phosphor-icons/react';

export default function Alerts(props) {
    const {
        alerts
    } = useAlertsContext();

    const {
        getToken
    } = useUserContext();

    const { 
        setModal,
        user
    } = props;

    const [fires, setFires] = useState(null);
    const [areas, setAreas] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [stage, setStage] = useState('Fire Alerts');
    const [alertsModal, setAlertsModal] = useState({ type: false, content: null });


    useEffect(() => {
        setLoading(true);

        getToken().then((token) => {
            axios.get('https://firewatch-api.space-eyes.com/user/manage-alerts', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            .then((res) => {
                setLoading(false);
                setFires(res.data.fires);
                setAreas(res.data.areas);
            }).catch((err) => {
                setLoading(false);
                setError('Trouble getting alerts. Please try again.');
                console.log('error getting alerts (managing)', err)
            }).catch((error) => {
                setLoading(false);
                setError('Trouble getting alerts. Please try again.');
                console.log('error getting token', error)
            })
        })
    }, []);

    const stageSwitch = () => {
        switch (stage) {
            case 'Fire Alerts':
                return (
                    <div className='alerts-page-content-table'>
                        {fires && fires.length > 0 ? (
                            fires.map((fire) => {
                                console.log(fire)
                                return (
                                    <AlertsFireCard 
                                        key={fire.fire_id}
                                        fire={fire}
                                        alerts={alerts}
                                        setModal={setAlertsModal}
                                        user={user}
                                    />
                                )
                            })
                        ) : (
                            <div style={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                padding: '2rem',
                                textAlign: 'center',
                                color: '#666'
                            }}>
                                <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                                    No fire alerts found
                                </div>
                                <div style={{ fontSize: '0.9rem' }}>
                                    You're not currently tracking any fires. Visit the Fires panel to start monitoring specific fires for updates.
                                </div>
                            </div>
                        )}
                    </div>
                )
            case 'Area Alerts':
                return (
                    <div className='alerts-page-content-table'>
                        {areas && areas.length > 0 ? (
                            areas.map((area) => (
                                <AlertsAreaCard 
                                    key={area.id}
                                    area={area}
                                    alerts={alerts}
                                    setModal={setAlertsModal}
                                    map={props.map}
                                />
                            ))
                        ) : (
                            <div style={{ 
                                display: 'flex', 
                                flexDirection: 'column', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                padding: '2rem',
                                textAlign: 'center',
                                color: '#666'
                            }}>
                                <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                                    No area alerts found
                                </div>
                                <div style={{ fontSize: '0.9rem' }}>
                                    You're not currently tracking any areas. Visit the Areas panel to create monitoring areas and set up alerts.
                                </div>
                            </div>
                        )}
                    </div>
                )
        }
    }

    return (
        <div className='alerts-page'>
            <div className='alerts-page-title'>
                {/* <img src={bellIcon} className='alerts-page-title-icon'/> */}
                <div className='alerts-page-title-text'>Alerts</div>
            </div>
            <div className='alerts-page-description'>Customize, track, and toggle alert settings for real-time wildfire and custom areas.</div>
            
            <div className='alerts-page-disclaimer'>
                <InfoIcon size={24} />
                <div className='alerts-page-disclaimer-text'>
                    <strong>Note:</strong> If you are in a team and have alerts for a team, they will not show in this panel. These are for custom alerts only.
                </div>
            </div>

            <div className='alerts-page-info'>
                <div className='alerts-page-info-section'>
                    <div className='alerts-page-info-section-title'>
                        <Fire size={16} weight="fill" color='#e82700'/>
                        Fire Alerts
                    </div>
                    <div className='alerts-page-info-section-description'>
                        Track specific fires and receive email notifications when they are updated with new information.
                    </div>
                </div>
                <div className='alerts-page-info-section'>
                    <div className='alerts-page-info-section-title'>
                        <MapPinAreaIcon size={16} weight='fill' color='#e82700'/>
                        Area Alerts
                    </div>
                    <div className='alerts-page-info-section-description'>
                        Monitor areas you've created. Get notified when fires enter your defined boundaries (polygon or radius).
                    </div>
                </div>
            </div>

            {error && <div style={{ fontSize: '0.9rem', fontWeight: 'bold', color: '#ff441c', marginTop: '1rem' }}>{error}</div>}
            {loading ?
            <div style={{ padding: '1rem' }}>
                <Spinner />
            </div>
            :
            <div className='alerts-page-content'>
                <div className='alerts-page-content-tabs'>
                    {['Fire Alerts', 'Area Alerts'].map((tab) => (
                        <div
                            key={tab}
                            className='alerts-page-content-tabs-tab'
                            style={{
                                borderBottom: tab === stage ? '2px solid #0080ff' : ''
                            }}
                            onClick={() => setStage(tab)}
                        >
                            {tab === 'Fire Alerts' ? `Fire Alerts (${fires?.length || 0})` : `Area Alerts (${areas?.length || 0})`}
                        </div>
                    ))}
                </div>
                {stageSwitch()}
                <div className='alerts-page-content-example'>
                    <PhotoProvider>
                        <PhotoView src={emailDemoIcon} >
                            <img src={emailDemoIcon} className='alerts-page-content-example-image'/>
                        </PhotoView>
                    </PhotoProvider>
                </div>
            </div>}
            <AlertsModal 
                modal={alertsModal}
                setModal={setAlertsModal}
            />
        </div>
    );
}